import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import login from './views/Login'
import register from './views/Register'

//Home
import home from './views/Home.vue'
//会社方針 policy
import policy from './views/Policy.vue'

//業務内容  business
import business from './views/Business.vue'
//設備一覧 business/equipment
//（設備名）business/equipment/(機器省略名)
import equipment from './views/business/Equipment.vue'
//import listDetail2 from './components/ListDetail2.vue'

//取扱素材 business/material
//（素材名）business/material/(素材省略名)
import material from './views/business/Material.vue'
//import goodsDetail from './views/products/GoodsDetail.vue'

//製作事例  product
//（製品名）/product/(製品省略名)
import products from './views/Products.vue'
//import PictureList from './components/PictureList.vue'
//import pictureDetail from './components/PictureDetail.vue'

//会社情報 about
import about from './views/About.vue'
//お知らせ /about/news
//お知らせ（タイトル）/about/news/(タイトル)
import announcement from './views/about/Announcement.vue'
//公式文章一覧
import official from './views/about/OfficialDocument.vue'

import listDetail from './components/AnyDetail.vue'

//製造ご依頼 /deal
import deal from './views/Deal.vue'
//import price from './views/deal/Price.vue'
//import line from './views/deal/Line.vue'

//お客様窓口 /customer
import customer from './views/Customer.vue'
//問い合わせフォーム /customer/contact
import contact from './views/Form2.vue'

//問い合わせフォーム /customer/contact2
//import contact2 from './views/Form.vue'


//FAQ /customer/faq
//import faq from './views/customer/Faq.vue'

//採用情報 /recruit
import recruit from './views/Recruit.vue'
//import recruit2 from './views/Recruit2.vue'

//サイト情報 
//プライバシーポリシー /site/privacy
//特定商取引に関して /site/commerce
//サイトマップ /site/sitemap
//ライセンス /site/lisence
import sitemap from './views/Sitemap.vue'

import notFound from './views/NotFound.vue'

/*開発中要素*/
//Home
//import home2 from './views/Home2.vue'


Vue.use(Router)

/* meta詳細
//ログイン認証 有無
requiresAuth: false
//右下ページ内リンクUI 有無
needsInnerNav: true
//ページ最下部 コンタクトボタン 有無
needsContactButton: true
//ページ右上コンタクトボタン群 有無
navIcon:true
//ナビゲーションバー、SNSボタン、コンタクトボタン、ページ内リンクUI表示
interfaceParts:false
//
addQuery:false
*/
const router = new Router({
    mode: 'history',
//		base: process.env.BASE_URL,
		strict: true,  //効かない
    routes: [
    {
      path: '/',
      name: 'オフィシャルサイト',
      component: home,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: true, navIcon:true, interfaceParts:false, addQuery:false },
    },
/*
    {
      path: '/home2',
      name: 'オフィシャルサイト2',
      component: home2,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: true, navIcon:true, interfaceParts:false, addQuery:false },
    },
*/
    {
      path: '/login',
      name: 'login',
      component:login,  
      meta: { requiresAuth: false, needsInnerNav: false, needsContactButton: true, navIcon:false, interfaceParts:true, addQuery:false },
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: { requiresAuth: false, needsInnerNav: false, needsContactButton: true, navIcon:false, interfaceParts:true, addQuery:false },
    },
    {
      path: '/policy',
      name: '会社方針',
      component: policy,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
			pathToRegexpOptions: { strict: true },
    },
    {
      path: '/customer',
      name: 'お客様窓口',
//      component: () => import( webpackChunkName: "about"  './views/Form.vue'),
      component: customer,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
			pathToRegexpOptions: { strict: true },
      children:[
        {
          path: 'contact',
          name: 'お問い合わせフォーム',
          component: contact,
          meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
					pathToRegexpOptions: { strict: true },
        },
/*
        {
          path: 'contact2',
          name: 'お問い合わせフォーム2',
          component: contact2,
          meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
					pathToRegexpOptions: { strict: true },
        },
        {
          path: 'faq',
          name: 'FAQ',
          component: faq,
          meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
					pathToRegexpOptions: { strict: true },
        },
*/
      ]
    },
    {
      path: '/deal',
      name: 'お見積り',
      component: deal,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: true, navIcon:false, interfaceParts:true, addQuery:false },
			pathToRegexpOptions: { strict: true },
    },
    {
      path: '/about',
      name: '会社情報',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: about,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: true, navIcon:false, interfaceParts:true, addQuery:false },
			pathToRegexpOptions: { strict: true },
      children:[
        {
          path:'announcement',
          name: 'お知らせ',
          component: announcement,
          meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:true },
					query: { list:1, },
					pathToRegexpOptions: { strict: true },
					children:[
							{
								path:':pageId',
								name:'お知らせ詳細',
								component:listDetail,
								meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
								props:true,
								pathToRegexpOptions: { strict: true },
							},
					]
        },
        {
          path:'official',
          name: '公式文章一覧',
          component: official,
          meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:true },
					query: { list:1, },
					pathToRegexpOptions: { strict: true },
        },
      ]
    },
    {
      path: '/products',
      name: '製作事例',
      component:products,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: true, navIcon:true, interfaceParts:true, addQuery:true },
			query: { list:1, },
			pathToRegexpOptions: { strict: true },
      children:[
					{
						path:':pageId',
						name:'製作詳細',
						component:listDetail,
						meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
						props:true,
						pathToRegexpOptions: { strict: true },
					},
       ]
    },
    {
      path: '/business',
      name: '事業内容',
      component:business,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: true, navIcon:true, interfaceParts:true, addQuery:false },
			pathToRegexpOptions: { strict: true },
      children:[
        {
          path:'equipment',
          name:'設備一覧',
          component:equipment,
          meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: true, navIcon:false, interfaceParts:true, addQuery:true },
					query: { list:1, },
					pathToRegexpOptions: { strict: true },
          children:[
            {
              path:':pageId',
              name:'設備詳細',
              component:listDetail,
              meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
              props:true,
							pathToRegexpOptions: { strict: true },
							//props: route => ({pageId: route.params.pageId, anyList: route.params.anyList, detail:route.params.detail}),
            },
					]
				},
        {
          path:'material',
          name:'取扱素材',
          component:material,
          meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: true, navIcon:false, interfaceParts:true, addQuery:true },
					query: { list:1, },
					pathToRegexpOptions: { strict: true },
				},
			]
    },
    {
      path: '/recruit',
      name: '採用情報',
      component:recruit,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
			pathToRegexpOptions: { strict: true },
    },
/*
    {
      path: '/recruit2',
      name: '採用情報',
      component:recruit2,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
			pathToRegexpOptions: { strict: true },
    },
*/
    {
      path: '/sitemap',
      name: 'サイト情報',
      component:sitemap,
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
			pathToRegexpOptions: { strict: true },
    },
		{
			path: '/:catchAll(.*)',
			name: '404NotFound',
			component: notFound,
//			redirect:'/notFound',
      meta: { requiresAuth: false, needsInnerNav: true, needsContactButton: false, navIcon:false, interfaceParts:true, addQuery:false },
		},
  ],

/*ページ移動した際にTOPから表示するための指定*/
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    if (savedPosition) {
      return savedPosition
    } else {
			return { x: 0, y: 0 }
    }
  },
})

export default router

router.beforeEach((to, from, next) => {
/*router.beforeRouteUpdate((to, from, next) => {*/
/*
親子で親が認証必要となっている場合、子ページも入れない。
これを解消するためには
to.matched.some(record => record.meta.requiresAuth)
ではなく
to.matched[to.matched.length-1].meta.requiresAuth)
が必要
*/
    //  if (to.matched.some(record => record.meta.requiresAuth)) {
  if (to.matched[to.matched.length-1].meta.requiresAuth) {
    if ( !store.getters.idToken) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
//console.log("CALL")
    next()
  }
})

